import {
    ListItemButton as UiListItemButton,
    Typography,
    styled,
} from "@l2r-front/l2r-ui"

const containerStyle = (theme) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(2, 0),
    width: "100%",
})

export const ListItemButton = styled(UiListItemButton)(({ theme }) => containerStyle(theme))

export const ListItemContainer = styled("div")(({ theme }) => containerStyle(theme))

export const ListItem = styled("div", { shouldForwardProp: prop => prop !== "variant" })(({ theme, variant }) => ({
    alignItems: "start",
    justifyContent: "center",
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: variant === "primary" ? 0 : theme.spacing(1),
    height: "100%",
    padding: theme.spacing(2, 0, 2, 0),
}))

export const ListItemHeader = styled("div")(() => ({
    alignItems: "center",
    display: "flex",
    height: "30px",
    justifyContent: "start",
    width: "100%",
}))

export const PrimaryTypography = styled(Typography)(({ theme }) => ({
    color: theme.palette["objects/object-black"].main,
}))

export const SecondaryTypography = styled(Typography, { shouldForwardProp: prop => prop !== "textColor" })(({ theme, textColor }) => ({
    color: theme.palette[textColor].main,
}))

export const Wrapper = styled("div")({
})

export const IconWrapper = styled("div")(({ theme }) => ({
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "center",
    display: "flex",
    height: "100%",
    marginRight: theme.spacing(8),
}))